export interface Loader {
    id: string;
    loadingText: string;
}

export enum LoadingActionTypes {
    Add = '[Loading] Add Loader',
    Remove = '[Loading] Remove Loader',
}
